import React from 'react';
import Header from '../../Components/Header/Header';
import SignUp from '../../Components/SignUp/SignUp';
import Footer from '../../Components/Footer/Footer.js';

const Signup = () => {
    return (
        <>
            <Header/>
            <SignUp/>
            <Footer/>
        </>
    );
};

export default Signup;